import { useCallback, useMemo, useState } from "react";

import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import {
  getDateRangeHeading,
  getInitialSelectionRange,
  parseMissingStatusFilter,
} from "../utils/reportUtils";

export function useMissingStatusDateFilter(onClose) {
  const [savedFilter, updateParams, removeSearchParam] =
    useCustomSearchParams("missingStatus");
  const filter = useMemo(
    () => parseMissingStatusFilter(savedFilter),
    [savedFilter]
  );
  const [selectionRange, setSelectionRange] = useState(
    getInitialSelectionRange(filter)
  );

  const handleSelect = useCallback((ranges) => {
    setSelectionRange([ranges.selection]);
  }, []);

  const submitSelection = useCallback(() => {
    updateParams("missingStatus", JSON.stringify(selectionRange[0]));
    onClose?.();
  }, [onClose, selectionRange, updateParams]);

  const resetSelection = useCallback(() => {
    onClose?.();
    removeSearchParam("missingStatus");
  }, [onClose, removeSearchParam]);

  return {
    filter,
    selectionRange,
    heading: getDateRangeHeading(filter),
    handleSelect,
    submitSelection,
    resetSelection,
  };
}
